<template>
    <div>
        <v-select
            v-model="model"
            v-bind="$attrs"
            :items="apps"
            :label="label"
            item-text="name"
            item-value="code"
            outlined
            return-object
        />
    </div>
</template>

<script>
    export default {
        name: 'UIAppPicker',

        props: {
            label: { type: String, default: 'Приложение' },
            value: { type: [Array, String], default: null },
        },

        data: () => ({
            apps: [
                {
                    name: 'МП жителя (Страна)',
                    value: '9f10f172-0230-4f2e-b1ab-4f0cdc24aed7',
                    code: 'mobile_app_strana',
                },
                {
                    name: 'МП жителя (Моя квартира)',
                    value: 'c3179db2-66b1-47d9-8443-91746a2f9b27',
                    code: 'mobile_app_my_flat',
                },
            ],
        }),

        computed: {
            model: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                },
            },
        },
    }
</script>
